import "./Home.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import HelpingPetsLiveHealthierHappierLives from "./sections/HelpingPetsLiveHealthierHappierLives";
import OurWellnessApproach from "./sections/OurWellnessApproach";
import EssentialDigitalTools from "./sections/EssentialDigitalTools";
import FreePetWeightTrackerSignup from "./sections/FreePetWeightTrackerSignup";
import LatestFromThePetWellnessBlog from "./sections/LatestFromThePetWellnessBlog";
import TrustedByPetParents from "./sections/TrustedByPetParents";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigationHeader />
      <HelpingPetsLiveHealthierHappierLives />
      <OurWellnessApproach />
      <EssentialDigitalTools />
      <FreePetWeightTrackerSignup />
      <LatestFromThePetWellnessBlog />
      <TrustedByPetParents />
      <SiteFooter />
    </div>;
}